// SPDX-License-Identifier: AGPL-3.0-or-later

import type {Channel} from '@app/features/channel/models/Channel';
import {DebugModal, type DebugTab} from '@app/features/devtools/components/debug/DebugModal';
import {useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';
import type React from 'react';
import {useMemo} from 'react';

interface ChannelDebugModalProps {
	title: string;
	channel: Channel;
}
export const ChannelDebugModal: React.FC<ChannelDebugModalProps> = observer(({title, channel}) => {
	const {t} = useLingui();
	const recordJsonData = useMemo(() => channel.toJSON(), [channel]);
	const tabs: Array<DebugTab> = [
		{
			id: 'record',
			label: t`Channel Record`,
			data: recordJsonData,
		},
	];
	return <DebugModal title={title} tabs={tabs} />;
});
